import { ProductTagBase } from '../ProductTagBase';
import { differenceInSeconds } from 'date-fns';
import klass from '../style/ProductTag.module.scss';
import { ProductTimeHelper } from '../../ProductCard/utils/ProductTimeHelper';

export class UpcomingTag extends ProductTagBase<Date> {
  protected override makeLabel(): string | undefined {
    const date = new Date(this.data.value);

    const diff_in_seconds = differenceInSeconds(date, new Date());
    if (diff_in_seconds < 0) {
      return undefined;
    }
    const diff = ProductTimeHelper.diffDate(new Date(date), new Date());
    const options = { ...diff, lng: this.data.lang };

    const ONE_HOUR = 3600;
    if (diff_in_seconds >= ONE_HOUR * 24 * 4) {
      return ET('mps2::product::tag::upcoming', { lng: this.data.lang });
    }
    if (diff_in_seconds >= ONE_HOUR * 24) {
      return ET('mps2::product::tag::upcoming_day', options);
    }
    if (diff_in_seconds >= ONE_HOUR) {
      return ET('mps2::product::tag::upcoming_hour', options);
    }
    if (diff_in_seconds > 60) {
      return ET('mps2::product::tag::upcoming_min', options);
    }
    return ET('mps2::product::tag::upcoming_soon', options);
  }

  protected styles(): string {
    return klass.upcoming;
  }

  protected isTimerNeeded(): boolean {
    return true;
  }
}
